/* Freddy's Signature: product page option changes (2026-10-25).
   Dawn disables Add to cart the moment an option is clicked and only re-enables it when the section fetch returns,
   so the button flashed grey (and could look sold out) on every Color / Diamond / Chain change. Here the button keeps
   its live look while that request is pending (data-fj-pending), and goes back to normal, or to a real Sold out /
   Unavailable state, as soon as Dawn reports the result. The quantity is also kept when an option changes. */
(function () {
  if (window.__fjPdpRestyle) return;
  window.__fjPdpRestyle = 1;
  var timer = null;
  function strings() { return window.variantStrings || {}; }
  function btn() { return document.querySelector('.product-form__submit[name="add"]'); }
  function label(b) { var s = b.querySelector('span'); return ((s ? s.textContent : b.textContent) || '').trim(); }
  function isLive(b) { return !b.disabled && label(b) === (strings().addToCart || 'Add to cart'); }
  function clear() { var b = btn(); if (b) b.removeAttribute('data-fj-pending'); clearTimeout(timer); }
  function settle() {
    var b = btn(); if (!b || !b.hasAttribute('data-fj-pending')) return;
    var addLabel = strings().addToCart || 'Add to cart';
    if (!b.disabled || label(b) !== addLabel) clear();
  }
  var savedQty = null;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('variant-selects')) return;
    var q = document.querySelector('.product-form__quantity .quantity__input');
    if (q) savedQty = parseInt(q.value, 10) || null;
    var b = btn();
    if (b && isLive(b)) {
      b.setAttribute('data-fj-pending', '1');
      clearTimeout(timer);
      timer = setTimeout(clear, 6000); /* safety: never leave it stuck if the request fails */
    }
  }, true);
  function init() {
    var b = btn();
    if (b) new MutationObserver(settle).observe(b, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(function () {
          clear();
          var q = document.querySelector('.product-form__quantity .quantity__input');
          if (!q || !savedQty) return;
          var min = parseInt(q.min, 10) || 1, max = q.max ? parseInt(q.max, 10) : null;
          if (savedQty >= min && (max === null || savedQty <= max)) q.value = savedQty;
        }, 0);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Buy box legends (2026-10-25): draws "METAL: 14K Yellow Gold" / "DIAMOND: Lab-Grown" / "CHAIN: Pendant Only" in each option legend.
   Adds one aria-hidden span.fjr-lg per legend (the original legend text stays for screen readers) and keeps it in step with the selected option,
   including after Dawn re-renders the option fieldsets. */
(function () {
  if (window.__fjPdpLegends) return;
  window.__fjPdpLegends = 1;
  function pretty(s) { return String(s || '').replace(/\b(\d+)KT\b/i, '$1K').toLowerCase().replace(/(^|[\s-])([a-z0-9])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  function paint(root) {
    var sets = (root || document).querySelectorAll('variant-selects fieldset.product-form__input--pill');
    for (var i = 0; i < sets.length; i++) {
      var fs = sets[i], lg = fs.querySelector(':scope > legend'); if (!lg) continue;
      var chk = fs.querySelector('input[type=radio]:checked');
      var isMetal = fs.classList.contains('fj-metal');
      var name = isMetal ? 'Metal' : (lg.getAttribute('data-fjr-lg') || lg.textContent.replace(/\s+/g, ' ').trim());
      var val = '';
      if (chk) {
        var tip = isMetal && chk.nextElementSibling && chk.nextElementSibling.querySelector('.fj-mtip');
        val = tip && tip.textContent.trim() ? tip.textContent.trim() : pretty(chk.value);
      }
      var span = lg.querySelector('.fjr-lg');
      if (!span) {
        span = document.createElement('span'); span.className = 'fjr-lg'; span.setAttribute('aria-hidden', 'true');
        span.innerHTML = '<b class="fjr-n"></b><span class="fjr-v"></span>';
        lg.setAttribute('data-fjr-lg', name); lg.appendChild(span);
      }
      var n = span.firstChild, v = span.lastChild, nt = name + (val ? ':' : '');
      n.style.fontWeight = 'inherit';
      if (n.textContent !== nt) n.textContent = nt;
      if (v.textContent !== val) v.textContent = val;
    }
  }
  var raf = 0;
  function soon() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; paint(); }); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-selects')) { paint(); setTimeout(paint, 80); setTimeout(paint, 400); }
  }, true);
  function init() {
    paint();
    if (window.MutationObserver) {
      var l = document.querySelectorAll('product-info, .product__info-container');
      for (var i = 0; i < l.length; i++) new MutationObserver(soon).observe(l[i], { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(paint, 0); setTimeout(paint, 200); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
